import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import ReactBSAlert from 'react-bootstrap-sweetalert'
import Loader from 'components/general/Loader'
import AdminAPI from 'config/api/AdminAPI'
import EnergyAPI from 'config/api/EnergyAPI'
import { onError } from 'config/lib/errorLib'
import InvoicesTab from 'components/admin/InvoicesTab'
import PendingTab from 'components/admin/PendingTab'
import componentStyles from 'assets/theme/views/admin/alternative-dashboard.js'
import componentStylesCardDeck from 'assets/theme/components/cards/card-deck.js'
import moment from 'moment-timezone'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

const useStyles = makeStyles(componentStyles)
const useStylesCardDeck = makeStyles(componentStylesCardDeck)

function Payments() {
	const classes = { ...useStyles(), ...useStylesCardDeck() }
	const api = new AdminAPI()
	const eApi = new EnergyAPI()

	const [tab, setTab] = useState(0)
    const [fsPayments, setFsPayments] = useState([])
	const [solarPayments, setSolarPayments] = useState([])
    const [fsCompanies, setFsCompanies] = useState([])
	const [solarCompanies, setSolarCompanies] = useState([])
	const [loading, setLoading] = useState(true)
	const [alert, setAlert] = useState(false)

	useEffect(() => {
		getPayments()
	}, [])

	async function getPayments() {
		try {
			const fsPayments = await api.getPayments()
			const solarPayments = await eApi.getPayments()
			fsPayments.sort((a, b) => {
				return moment(b.date).valueOf() - moment(a.date).valueOf()
			})
            console.log('fsPayments: ', fsPayments)
			solarPayments.sort((a, b) => {
				return moment(b.date).valueOf() - moment(a.date).valueOf()
			})
            console.log('solarPayments: ', solarPayments)

            const fsCompanies = await api.getCompanies()
            const solarCompanies = await eApi.getCompanies()
            const activeFsCompanies = fsCompanies.filter((company) => (company.active))
            const activeSolarCompanies = solarCompanies.filter((company) => (company.active))
            activeFsCompanies.sort((a, b) => {
				return a.name.localeCompare(b.name)
			})
            activeSolarCompanies.sort((a, b) => {
				return a.name.localeCompare(b.name)
			})

			setFsPayments(fsPayments)
            setSolarPayments(solarPayments)
			setFsCompanies(activeFsCompanies)
            setSolarCompanies(activeSolarCompanies)
			setLoading(false)
		} catch(e) {
			onError(e)
		}
	}

	function updatePayment(type, payment) {
        const index = type === 'Financial' ? fsPayments.findIndex(oldPayment => (oldPayment.companyId === payment.companyId && oldPayment.date === payment.date)) : solarPayments.findIndex(oldPayment => (oldPayment.companyId === payment.companyId && oldPayment.date === payment.date))
		console.log('payment index: ', index)

		let newPayments = type === 'Financial' ? [...fsPayments] : [...solarPayments]
		newPayments[index] = payment
		// let checkStatus = showStatus === 'paid' ? true : false
		// let showPayments = newPayments.filter((payment) => (payment.paid === checkStatus))
		// console.log('check status: ', checkStatus)
		// console.log(showPayments)
        if (type === 'Financial') {
			setFsPayments(newPayments)
		} else {
			setSolarPayments(newPayments)
		}
	}

	function showSuccessAlert(text) {
		setAlert(
			<ReactBSAlert
				success
				style={{ display: 'block', marginTop: '-100px' }}
				title='Success'
				onConfirm={() => setAlert(false)}
				onCancel={() => setAlert(false)}
				confirmBtnBsStyle='success'
				confirmBtnText='Ok'
				btnSize=''
				confirmBtnStyle={{
					marginRight: undefined,
					borderColor: undefined,
					boxShadow: undefined,
				}}
			>
				{text}
			</ReactBSAlert>
		)
	}

	const handleTabChange = (event, newValue) => {
		setTab(newValue)
	}

	return (
		<>
			{alert}
			<Container
				maxWidth={false}
				component={Box}
				marginTop='2rem'
				classes={{ root: classes.containerRoot }}
			>
				{loading ? (
					<Box display="flex" justifyContent="center" alignItems="center" style={{height: '20vh'}}>
						<Loader />
					</Box>
				) : (
					<>
						<Tabs
							value={tab}
							onChange={handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="standard"
							style={{ marginBottom: '2rem' }}
						>
							<Tab label="Pending" />
							<Tab label="Invoices" />
						</Tabs>
						{tab === 0 && (
							<PendingTab 
								fsPayments={fsPayments.filter(payment => payment.status === 'pending')}
								solarPayments={solarPayments.filter(payment => payment.status === 'pending')}
								fsCompanies={fsCompanies}
								solarCompanies={solarCompanies}
								updatePayment={updatePayment}
								refreshPayments={getPayments}
								showSuccessAlert={showSuccessAlert}
							/>
						)}
						{tab === 1 && (
							<InvoicesTab
								fsPayments={fsPayments.filter(payment => payment.status !== 'pending')}
								solarPayments={solarPayments.filter(payment => payment.status !== 'pending')}
								fsCompanies={fsCompanies}
								solarCompanies={solarCompanies}
								getPayments={getPayments}
								updatePayment={updatePayment}
								showSuccessAlert={showSuccessAlert}
							/>
						)}
					</>
				)}
			</Container>
		</>
	)
}

export default Payments